/* tslint:disable */

export class Color {
    rgb: {
        r: number,
        g: number,
        b: number
    }

    hex: string

    constructor(hex) {
        this.hex = hex;
        this.rgb = Color.hexToRgb(hex);
    };

    static generateRandomColor() {
        let all_letters = '0123456789ABCDEF';
        let dark_letters = '0123456789';
        let light_letters = 'ABCDEF';
        let hexColor = '#';
        for (let i = 0; i < 6; i++) {
            if (i % 2 === 0) {
                hexColor += all_letters[Math.floor(Math.random() * 16)];
            } else {
                hexColor += dark_letters[Math.floor(Math.random() * 10)];
            }
        }

        let color = new Color(hexColor);

        return color;
    }

    static generateRandomColorList(number_of_colors) {
        let colors = [];
        for (let i = 0; i < number_of_colors; i++) {
            let random_color = Color.generateRandomColor();
            colors.push(random_color);
        }
        return colors;
    }

    static generateSameColorList(hexColor, count) {
        let colors = [];
        for (let i = 0; i < count; i++) {
            colors.push(new Color(hexColor));
        }
        return colors;
    }

    static getOrderedColorsScheme(count) {
        let colors_pool = [];
        if (count <= 5) {
            colors_pool = ['#e41a1c', '#377eb8', '#4daf4a', '#984ea3', '#ff7f00'];
        } else if (count > 5 && count <= 8) {
            colors_pool = ['#e41a1c', '#377eb8', '#4daf4a', '#984ea3', '#ff7f00', '#ffff33', '#a65628', '#f781bf'];
        } else {
            // return ['#ff0080' , '#bf4080', '#e23841', '#00ff80', '#80bf40', '#ffff00', '#ff8000', '#409fff', '#00ffff', '#d9d9d9', '#bc80bd', '#ccebc5', '#ffed6f'];
            colors_pool = ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c', '#fb9a99', '#e31a1c', '#fdbf6f', '#ff7f00', '#ff0080', '#6a3d9a', '#ffff99', '#b15928'];
        }
        let ordered_colors_list = [];
        for (let i = 0; i < count; i++) {
            ordered_colors_list.push(new Color(colors_pool[i]));
        }
        return ordered_colors_list;
    }

    static hexToRgb(hex) {
        let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16) / 255,
            g: parseInt(result[2], 16) / 255,
            b: parseInt(result[3], 16) / 255
        } : null;
    }

    static rgbToHex(rgbColor) {
        return "#" + ((1 << 24) + (rgbColor.r * 255 << 16) + (rgbColor.g * 255 << 8) + rgbColor.b * 255).toString(16).slice(1);
    }
}
